import { createFileRoute, redirect } from "@tanstack/react-router";
import AdminLogin from "@/components/AdminLogin";
import { supabase } from "@/integrations/supabase/client";

/**
 * Standalone sign-in page. The admin portal also renders the same form
 * inline when a visitor is not signed in.
 */
export const Route = createFileRoute("/auth")({
  ssr: false,
  head: () => ({
    meta: [
      { title: "Sign in, Casa Mi Pajobe" },
      { name: "description", content: "Admin sign in for Casa Mi Pajobe booking management." },
      { name: "robots", content: "noindex, nofollow" },
      { property: "og:title", content: "Sign in, Casa Mi Pajobe" },
      { property: "og:description", content: "Admin sign in for Casa Mi Pajobe booking management." },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
    ],
  }),
  validateSearch: (s: Record<string, unknown>): { next?: string } =>
    typeof s.next === "string" && s.next.startsWith("/") && !s.next.startsWith("//")
      ? { next: s.next }
      : {},
  beforeLoad: async ({ search }) => {
    const { data } = await supabase.auth.getUser();
    if (data.user) {
      throw redirect({ href: search.next ?? "/admin", replace: true });
    }
  },
  component: AuthPage,
});

function AuthPage() {
  return <AdminLogin />;
}
